import { render, staticRenderFns } from "./SwipeAction.vue?vue&type=template&id=29439002&scoped=true"
import script from "./SwipeAction.vue?vue&type=script&lang=js"
export * from "./SwipeAction.vue?vue&type=script&lang=js"
import style0 from "./SwipeAction.vue?vue&type=style&index=0&id=29439002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29439002",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
